export const PlaceholderBlock = ({ label, ratio, fill = false, dark = false, className = "" }) => (
  <figure
    role="img"
    aria-label={`Placeholder: ${label}`}
    style={fill ? undefined : { aspectRatio: ratio }}
    className={`relative m-0 overflow-hidden border ${
      dark ? "border-paper/15 bg-paper/[0.04]" : "border-line bg-paper2"
    } ${fill ? "h-full w-full" : "w-full"} ${className}`}
  >
    <svg className="absolute inset-0 h-full w-full" preserveAspectRatio="none" aria-hidden="true">
      <line x1="0" y1="0" x2="100%" y2="100%" stroke="currentColor" strokeWidth="1" className={dark ? "text-paper/10" : "text-line"} />
      <line x1="100%" y1="0" x2="0" y2="100%" stroke="currentColor" strokeWidth="1" className={dark ? "text-paper/10" : "text-line"} />
    </svg>
    <span className={`absolute left-3 top-3 font-mono text-[10px] tracking-[0.14em] ${dark ? "text-paper/40" : "text-ink2/70"}`}>
      AKLIVE / ASSET
    </span>
    {ratio && (
      <span className={`absolute bottom-3 right-3 font-mono text-[10px] tracking-[0.14em] ${dark ? "text-paper/40" : "text-ink2/70"}`}>
        {ratio.replace(" / ", ":")}
      </span>
    )}
    <span className="absolute inset-0 flex items-center justify-center p-4">
      <figcaption className={`text-center font-mono text-[11px] tracking-[0.14em] sm:text-xs ${dark ? "text-paper/60" : "text-ink2"}`}>
        {label}
      </figcaption>
    </span>
  </figure>
);
